module.exports = __webpack_public_path__ + "static/img/background_02.f211c01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/background_02.png
// module id = ZAFI
// module chunks = 1